var React = require('react');

function Appcenter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#CB2E62","fillRule":"nonzero","style":{"fill":"#CB2E62"}},[React.createElement("path",{"fill":"#CB2E62","d":"M18 20.6l6 .9-6 2.5-18-6 18 2.6V0l6 2.5v19z","style":{"fill":"#CB2E62"},"key":0}),React.createElement("path",{"fill":"#CB2E62","d":"M6 4l2.3.5v3.6L12 5.5v3l-3.8 2 3.8 2v3l-3.8-2.6v3.6L6 17l-4-3.5V12l2.3-1.5L2 9V7.5L6 4zM3.2 8.1L6 9.5V6L3.2 8.1zM6 15v-3.5l-2.8 1.4L6 15zm6-9.5l3 1v8l-3 1v-10z","style":{"fill":"#CB2E62"},"key":1})]));
}

Appcenter.defaultProps = {"width":"24","height":"24"};

module.exports = Appcenter;

Appcenter.default = Appcenter;
